export default __webpack_public_path__ + "static/media/email.40573d88.svg";